'use client';

import { useUser } from '@providers/UserProvider';

const AdminWarning = () => {
  const user = useUser();

  const isAdmin = user?.contact_type === 'admin';

  return (
    <>
      {isAdmin && (
        <div className="admin-warning-banner">
          <i className="mdi mdi-alert-circle" />
          <p>You are currently logged in as Admin. Use caution!</p>
        </div>
      )}
    </>
  );
};

export default AdminWarning;
